// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ../src/css/card.scss
// module id = 24
// module chunks = 0